<template>
  <div
    class="bandana-new-pack-notice position-relative"
    style="
      background: linear-gradient(to bottom, #f46a4533, #cd491c33), url('https://img.fortawesome.com/1ce05b4b/wa-pattern.svg') repeat, linear-gradient(to bottom, #f46a45 , #cd491c);
      background-size: 100% 150%, auto, 100% 150%;
      background-repeat: no-repeat, repeat, no-repeat;
      color: white;
    "
  >
    <div class="container">
      <div class="row roomy padding-y-2xl">
        <div class="column-12 display-flex">

          <!-- Desktop Icon -->
          <div
            class="display-none tablet:display-flex laptop:align-middle align-left padding-y-md padding-right-md"
            style="flex-shrink: 0; flex-grow: 0"
          >
            <div
              class="icon-box"
              style="
                width: 52px;
                height: 52px;
                border-radius: 8px;
                background-color: #f46a45;
                border: 2px solid white;
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <i class="fa-solid fa-xl fa-web-awesome"></i>
            </div>
          </div>

          <!-- Content + Buttons -->
          <div
            class="tablet:display-flex align-between align-middle"
            style="--button-margin-bottom: 0; flex-grow: 1"
          >
            <div class="display-flex">

              <!-- Mobile Icon -->
              <div
                class="tablet:display-none padding-right-lg"
                style="flex-shrink: 0; flex-grow: 0"
              >
                <div
                  class="icon-box"
                  style="
                    width: 52px;
                    height: 52px;
                    border-radius: 8px;
                    background-color: #f46a45;
                    border: 2px solid white;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <i class="fa-solid fa-2x fa-web-awesome"></i>
                </div>
              </div>

              <!-- Text -->
              <div>
                <p
                  class="padding-right-2xl"
                  style="font-size: 20px; line-height: 1.25em;"
                >
                  <strong>Web Awesome has landed!</strong>
                  No frameworks. No build steps. Just clean, fast web components.
                </p>
              </div>
            </div>

            <!-- Buttons -->
            <div
              class="margin-top-lg tablet:margin-top-0 flex-row tablet:flex-column laptop:flex-row"
              style="display: flex; gap: var(--spacing-xs); flex-shrink: 0"
            >
              <a
                href="https://webawesome.com/?utm_source=fontawesome&utm_medium=banner&utm_campaign=launch"
                class="button flat"
                style="
                  --button-color: var(--fa-navy);
                  --button-background: white;
                  --button-hover-background: #FFAF99;
                  --button-hover-color: var(--fa-navy);
                  flex-grow: 1;
                "
                target="_blank"
              >
                <i class="fa-solid fa-xl fa-arrow-up-right-from-square margin-right-xs"></i>
                Explore WA
              </a>
              <a
                href="https://webawesome.com/purchase?utm_source=fontawesome&utm_medium=banner&utm_campaign=launch"
                class="button flat"
                style="
                  --button-color: white;
                  --button-background: var(--fa-navy);
                  --button-hover-background: #FFAF99;
                  --button-hover-color: var(--fa-navy);
                  flex-grow: 1;
                "
                target="_blank"
              >
                <i class="fa-solid fa-xl fa-rocket-launch margin-right-xs"></i>
                20% Off Launch Sale
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WebAwesomeReleaseNotice'
}
</script>
